




















import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import CardSosial from "@/components/kunjunganPasien/CardSosial.vue";
import { storePasien } from "@/store/modules/pasien";
import CardKunjungan from "@/components/kunjunganPasien/CardKunjungan.vue";
import { Route } from "vue-router";
import { storeRiwayat } from "@/store/modules/riwayat";
import { resepStore } from "@/store/modules/resep";
import { storePenunjang } from "@/store/modules/penunjang";
import { storeResepFarmasi } from "@/store/modules/resepfarmasi";
import { storeSuket } from "@/store/modules/suket";
import AsuhanKebidananGadarStore from "@/store/modules/AsuhanKebidananGadarStore";
import AsuhanKeperawatanGadarStore from "@/store/modules/AsuhanKeperawatanGadarStore";
import AsesmenAwalGadar from "@/store/modules/AsesmenAwalGadar";
import { storeResume } from "@/store/modules/resume";
import storeBilling from "@/store/modules/Billing";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import ResumeRanapStore from "@/store/modules/ResumeRanapStore";
import storeAsesmenKemoterapi from "@/store/modules/AsesmenKemoterapi";
import storeProtokolKemoterapi from "@/store/modules/ProtokolKemoterapi";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import TandaVitalStore from "@/store/modules/TandaVitalStore";
import LaporanOperasi from "@/store/modules/LaporanOperasi";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import CpptRanapStore from "@/store/modules/CpptRanapStore";
import CatatanPemberianObatStore from "@/store/modules/CatatanPemberianObat";
import { resetStoreDetailPasien } from "@/utils/resetStorePasien";

@Component({
  components: {
    CardSosial,
    CardKunjungan
  },

  beforeRouteLeave(to, from, next) {
    const paramlistpasien = {
      rm: this.rm,
      expand: "asesmen_awal_ralan,unit_journey"
    };
    storePasien.act_pasien(this.rm);
    // storeSoap.clear_soap_all();
    SoapRanapStore.reset();
    storeRiwayat.act_list(paramlistpasien);
    resepStore.setResep([]);
    storePenunjang.clear_list_ro();
    storePenunjang.clear_list_lab();
    storePenunjang.clear_hasil_ro();
    storePenunjang.clear_penunjang_lain();
    storeResepFarmasi.clear_list_resepfarmasi();
    storeResepFarmasi.clear_detail_resepfarmasi();
    storeSuket.clear_riwayatSK();
    AsuhanKebidananGadarStore.clearListAskeb();
    AsuhanKeperawatanGadarStore.clearListAskep();
    AsesmenAwalGadar.clearData();
    storeResume.clearResume();
    storeBilling.clearBilling();
    AsesmenAwalRanapMedisStore.reset();
    ResumeRanapStore.reset();
    storeAsesmenKemoterapi.reset();
    storeProtokolKemoterapi.reset();
    storeAssesmenRalan.reset();
    TandaVitalStore.reset();
    LaporanOperasi.reset();
    CpptRanapStore.reset();
    CatatanPemberianObatStore.reset();
    next();
  }
})
export default class DetailPasien extends Vue {
  rm = "";

  created() {}
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newVal: Route) {
    if (newVal.name !== "detail-pasien") return;

    const rm = newVal.params.rm;
    if (!rm || rm === this.rm) return;

    this.rm = rm;
    resetStoreDetailPasien();
    storePasien.act_pasien(rm);
    storeRiwayat.act_list({
      rm,
      expand: "asesmen_awal_ralan,unit_journey"
    });
  }
}
